<script>
import { BTableLite} from "bootstrap-vue";

export default {
  extends: BTableLite
};
</script>